module.exports = __webpack_public_path__ + "img/template-tutorial-customize-spotify-before.7f864477.png";